import { mpx } from '@didi/es-mpx-creator'
import { GET_ACC_PACK_DETAIL, GET_ACC_PACK_CONTENT, ACC_PACK_STATUS_UPDATE } from '@/api/urls'

/**
 * @method 获取加速包明细信息
 * @param params
 * @returns {Promise}
 */
export const getAccPackDetailApi = data => {
  return mpx.$http.post(GET_ACC_PACK_DETAIL, { data })
}

/**
 * @method 获取加速包助力页面相关信息
 * @param params
 * @returns {Promise}
 */
export const getAccShareContentApi = data => {
  return mpx.$http.post(GET_ACC_PACK_CONTENT, { data })
}

/**
 * @method 获取好友助力
 * @param params
 * @returns {Promise}
 */
export const accPacStatusUpdateApi = data => {
  return mpx.$http.post(ACC_PACK_STATUS_UPDATE, { data })
}


